export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Regular.a0490f0856f31249107114567ddcd7ae.ttf";